// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ShiftsAreaId } from './ShiftsAreaId'
import { ShiftsAreaNavigation } from './ShiftsAreaNavigation'
import { ShiftsAreaRoutes } from './ShiftsAreaRoutes'

const LazyShiftsComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./ShiftsArea')),
)

const ShiftsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyShiftsComponent />
  </SuspenseLoadingWrapper>
)

export const ShiftsArea = {
  id: ShiftsAreaId,
  requiredRight: BoumRight.AREA_SHIFTS,
  NavigationComponent: ShiftsAreaNavigation,
  route: {
    path: ShiftsAreaRoutes.route,
    component: ShiftsComponent,
  },
}
